export const getEnvVar = function (varName) {
  if (!varName || typeof varName !== 'string' || !varName.length) {
    return false;
  }

  return process.env[varName] && (process.env[varName]).toLowerCase().trim();
}

export const featureEnabled = function (featureEnv, defaultValue = false) {
  const envVar = getEnvVar(featureEnv);

  if (typeof envVar === 'string') {
    return envVar === 'true';
  } else if (typeof envVar === 'boolean') {
    return envVar;
  }

  return defaultValue;
}
